export default annotations => window.documentViewer.getAnnotationManager().ungroupAnnotations(annotations);